/**
 * Sale tips 折扣码复制。
 * 全页只绑一次点击。每个按钮用自己的 data-code 和定时器，
 * 产品循环里点一个，不会改到其它卡片。
 */
if (!window.__saleTipsCopyBound) {
  window.__saleTipsCopyBound = true;

  var bindSaleTipsCopy = function () {
    if (window.__saleTipsCopyListening) return;
    window.__saleTipsCopyListening = true;

    var setLabel = function (btn, text) {
      var label = btn.querySelector('.sale_tips_copy_label');
      if (label) label.textContent = text;
      else btn.textContent = text;
    };

    /* 未设置 button_bg_color 时，底色跟这条文案一致；设置了就不再改 */
    var syncColor = function (btn) {
      if (btn.getAttribute('data-bg-locked') === 'true') return;
      if (btn.getAttribute('data-color-synced') === 'true') return;
      var host = btn.closest('.sale_tips_text');
      var field = host && host.querySelector('.metafield-rich_text_field');
      /* 只取富文本颜色，避开按钮自己的白色文字 */
      var probe = (field && (field.querySelector('p, span, strong') || field)) || host;
      if (!probe) return;
      var color = window.getComputedStyle(probe).color;
      if (!color) return;
      btn.style.backgroundColor = color;
      btn.setAttribute('data-color-synced', 'true');
    };

    document.querySelectorAll('.sale_tips_copy').forEach(syncColor);

    /* 变体价是分。百分比用倍率，固定金额用要减掉的分数，和 Liquid 同一套规则。 */
    var formatSaleMoney = function (cents, format) {
      var formatString = format || '${{amount}}';
      var placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!placeholder) return formatString;

      var withDelimiters = function (number, precision, thousands, decimal) {
        var fixed = (number / 100).toFixed(precision);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return parts.join(decimal);
      };

      var value = '';
      switch (placeholder[1]) {
        case 'amount':
          value = withDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', '.');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = withDelimiters(cents, 2, ' ', '.');
          break;
        default:
          value = withDelimiters(cents, 2, ',', '.');
      }

      return formatString.replace(placeholder[0], value);
    };

    /* 产品卡会在冒泡阶段停掉 variant:update，所以用捕获阶段先收到。只改同一产品的 Now 价。 */
    document.addEventListener('variant:update', function (event) {
      var detail = event.detail;
      var variant = detail && detail.resource;
      var productId = detail && detail.data && detail.data.productId;
      if (!variant || productId == null || variant.price == null) return;

      var basePrice = Number(variant.price);
      if (!isFinite(basePrice)) return;

      document.querySelectorAll('.sale_tips_price[data-product-id="' + productId + '"]').forEach(function (node) {
        var mode = node.getAttribute('data-sale-mode');
        var factor = Number(node.getAttribute('data-sale-value'));
        if (!mode || !isFinite(factor)) return;

        var nextPrice = mode === 'percent' ? Math.round(basePrice * factor) : basePrice - factor;
        /* money_format 里可能带 span，只留金额文字 */
        var formatted = formatSaleMoney(nextPrice, node.getAttribute('data-money-format')).replace(/<[^>]*>/g, '');
        node.textContent = 'Now ' + formatted;
      });
    }, true);

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        var btn = target && target.closest ? target.closest('.sale_tips_copy') : null;
        if (!btn) return;

        /* 捕获阶段先拦住，避免点到外层产品链接 */
        event.preventDefault();
        event.stopPropagation();

        syncColor(btn);

        var code = (btn.getAttribute('data-code') || '').trim();
        if (!code) return;

        var markCopied = function () {
          if (btn._saleTipsTimer) window.clearTimeout(btn._saleTipsTimer);
          setLabel(btn, 'COPIED');
          btn.setAttribute('aria-label', 'Copied');
          /* 2 秒后只还原当前按钮 */
          btn._saleTipsTimer = window.setTimeout(function () {
            setLabel(btn, 'COPY');
            btn.setAttribute('aria-label', 'Copy discount code ' + code);
            btn._saleTipsTimer = null;
          }, 2000);
        };

        var copyFallback = function (text) {
          return new Promise(function (resolve, reject) {
            try {
              var ta = document.createElement('textarea');
              ta.value = text;
              ta.setAttribute('readonly', '');
              ta.setAttribute('aria-hidden', 'true');
              ta.style.position = 'fixed';
              ta.style.top = '0';
              ta.style.left = '0';
              ta.style.width = '1px';
              ta.style.height = '1px';
              ta.style.opacity = '0';
              document.body.appendChild(ta);
              ta.focus();
              ta.select();
              var ok = document.execCommand('copy');
              document.body.removeChild(ta);
              if (ok) resolve();
              else reject();
            } catch (err) {
              reject(err);
            }
          });
        };

        var copyText =
          navigator.clipboard && navigator.clipboard.writeText
            ? navigator.clipboard.writeText(code).catch(function () {
                return copyFallback(code);
              })
            : copyFallback(code);

        copyText.then(markCopied).catch(function () {});
      },
      true
    );
  };

  /* 首屏走 DOMContentLoaded；脚本晚于页面加载时直接绑定 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSaleTipsCopy);
  } else {
    bindSaleTipsCopy();
  }
}
